export type Artist = "riize" | "aespa";

export const ARTIST = {
  riize: "riize",
  aespa: "aespa",
} as const;

const isValidArtist = (value: string): value is Artist => {
  return value === ARTIST.riize || value === ARTIST.aespa;
};

export const getArtistFromPath = (pathname: string): Artist => {
  const segments = pathname.split("/");
  const artist = segments[1];

  if (!artist) {
    return ARTIST.riize;
  }

  if (isValidArtist(artist)) {
    return artist;
  }

  return ARTIST.riize;
};

export const getSessionPath = (pathname: string): string => {
  const segments = pathname.split("/");
  const sessionPath = segments[2];
  return `/${sessionPath}`;
};

export const convertArtistToType = (artist: Artist): 1 | 2 => {
  return artist === ARTIST.aespa ? 1 : 2;
};
